import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getTeamLogo } from "../../utils/General";

const GrandPrixTeam = (props: any) => {
  const driver = props.driver;
  const { t } = useTranslation();
  if (driver.team == null || driver.team_flag === "unk")
    return (
      <div className="gp-team">
        <span>{driver.team}</span>
      </div>
    );
  return (
    <div className="gp-team flex-center">
      {driver.team_id != null && (
        <>
          <Link to={`${t("routes:Team")}/${encodeURIComponent(driver.team)}`}>
            {driver.team}
          </Link>
          <div className="team-logo-container">
            <img
              title={driver.team}
              src={`/assets/Teams/${getTeamLogo(
                driver.team_id,
                driver.team_logo
              )}.png?dummy=${Math.floor(Math.random() * 1001)}`}
            />
          </div>
        </>
      )}

      {driver.team_id == null && driver.team != null && (
        <>
          <span>{driver.team}</span>
          <div className="team-logo-container">
            <img
              title={driver.team}
              src={`/assets/Teams/General/${getTeamLogo(
                driver.team.split(" ")[0],
                driver.team_logo === "" ? null : driver.team_logo
              )}.png?dummy=${Math.floor(Math.random() * 1001)}`}
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default GrandPrixTeam;
